import React, { useState, useRef, useEffect } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Card,
    styled,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText
} from '@mui/material';

import {
    LoadingButton
} from '@mui/lab';

import { useNavigate, useSearchParams } from 'react-router-dom';

import { useFormik } from 'formik';

import { useAppContextFeatures } from "../../../context/AppContext";
import { useAuthAccess } from "../../../hooks/useAuthAccess";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from "../../common/CommonRestricted";
import DatePickerComponent from "../../common/DatePickerComponent";
import LocationSelector from "../../selector/LocationSelector";

import SearchSuppliers from "../../dialog/SearchSuppliers";
import SearchItems from "../../dialog/SearchItems";
import SearchDocuments from "../../dialog/SearchDocuments";
import { useStatePurchaseInvoice } from "../../../hooks/state/loadFrom/documents/useStatePurchaseInvoice";

import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { CommonIcons, icons } from "../../common/CommonIcons";
import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useTranslations } from '../../../hooks/useTranslations';
import { useDocumentAdjustments } from "../../../hooks/state/useDocumentAdjustments";

import {
    loadFromDocumentTypes,
    LoadFromDocuments
} from "../../dialog/LoadFromDocuments";

import { checkValueExists, calculateSummaryRows } from "../../../utils/dataSchema";
import {
    validationSchema,
    initialValues,
    initialRowValues
} from "../../../schema/documents/purchaseInvoiceSchema"

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    // opacity: 0.1,
    //   backgroundColor: "green",
    //   color: 'inherit',
    //   display: 'flex',
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

export default function NewPurchaseInvoice({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@document", "prompt"] })

    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    const { getAvailableLocations } = useAuthAccess();
    const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.document.id, scopeTypes.document.purchaseInvoice.id)

    const { setSystemLoading } = useAppContextFeatures();
    const { isLoading, create, filterOperatorTypes } = useDocuments({ 
        documentType: documentTypes.purchaseInvoice, 
        targetType: targetTypes.purchaseInvoice
    })
    const { updateFormikState, getFormikDependencyStates } = useStatePurchaseInvoice()

    // const [ selectLocationIds, setSelectLocationIds ] = useState()

    const availableLocations = getAvailableLocations();
    const [preview, setPreview] = useState(false)

    // const [searchDocumentConfig, setSearchDocumentConfig] = useState({
    //     show: false,
    //     documentType: documentTypes.purchaseInvoice,
    //     keyword: ""
    // })

    const [loadDocumentConfig, setLoadDocumentConfig] = useState({
        show: false,
        documentId: loadFromDocumentTypes.purchaseInvoice.id,
        documentType: loadFromDocumentTypes.purchaseInvoice.type,
        // documentType: documentTypes.salesOrder,
        keyword: ""
    })

    const onSubmit = async (currentValues) => {

        const document = {
            doc_date: currentValues.documentDate.format("YYYY-MM-DD"),
            doc_remark: currentValues.remark,
        }

        const profiles = {
            supplier: {
                user_id: currentValues.userId
            }
        }

        const props = {
            location_id: currentValues.locationId,
        }

        let items = [];

        currentValues.rows.map(item => {
            items.push({
                id: item?.itemId,
                code: item?.code,
                name: item?.name,
                description: item?.description,
                qty: item?.qty,
                uom_lbl: item?.uomName,
                uom: item?.uomId,
                price: item?.price,
            })
            return false;
        })

        let adjustments = getPayloadSubmitCreate()

        try {

            let data = {
                document,
                profiles,
                props,
                items,
                adjustments,
                ...getFormikDependencyStates({ values })
            }

            const response = await create({ data });

            // console.log('response', response)

            promptMessage(true, `${response?.message}`)

            navigate(getRoute("documents/purchaseInvoices"))

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue, } = formik;

    const {
        getAmount,
        calculateSummaryRows,
        updateTaxPreviewOpen,
        RenderDocumentSummary,
        RenderDocumentTaxPreview,
        getPayloadSubmitCreate
    } = useDocumentAdjustments({
        formik,
        disableTax: false,
        documentType: documentTypes.purchaseInvoice,
        handlePreviewChange: (val) => {
            // console.log('current open', val)
            setPreview(val)
        }
    })

    useEffect(() => {

        updateTaxPreviewOpen(preview)

    }, [preview])

    useEffect(() => {

        calculateSummaryValues();

    }, [values])

    // useEffect(() => {

    //     const searchParamsAction = searchParams.get('action');
    //     const searchParamsPayload = searchParams.get('payload');

    //     // console.log('searchParams', searchParamsAction, searchParamsPayload)

    //     if (searchParamsAction && searchParamsAction.toLowerCase() === 'duplicate') {
    //         setSearchDocumentConfig(prev => ({ ...prev, show: true, documentType: documentTypes.purchaseInvoice, keyword: searchParamsPayload }))
    //     }

    // }, [])

    // const updateDefaultFields = () => {

    //     // update the auth data
    //     // setFieldValue("retailOutletUserId", authData?.profile?.user?.id)

    //     // get use the parent user id
    //     setFieldValue('userId', authData?.profile?.parent_user_id)

    //     if(selectLocationIds && selectLocationIds.length){
    //         const check = availableLocations.filter(i => i.id === selectLocationIds[0])
    //         // console.log('check', check)
    //         if(check.length){

    //             // use the selected one branch location id
    //             setFieldValue('shippingBranchId', check[0].branch_id)

    //             // use the selected one brandh billing branch id
    //             setFieldValue('billingBranchId', check[0].billing_branch_id)

    //         }
    //     }

    // }

    // useEffect(() => {

    //     updateDefaultFields()

    // }, [selectLocationIds])

    useEffect(() => {

        const currentLocationIds = getLocationIds();

        // setSelectLocationIds(currentLocationIds)

        if (currentLocationIds.length > 0) {
            // console.log('currentLocationIds', currentLocationIds, availableLocations)

            // get the location information
            const loc = availableLocations.filter(item => item.id === currentLocationIds[0])

            if (loc.length) {
                setFieldValue("locationId", loc[0].id)
                setFieldValue("locationName", loc[0].location_name)
            }
        }

    }, [getLocationIds])

    const getBreadcumbActionMenus = () => {

        let props = []

        if (isPermissionAllow({ functionType: functionTypes.pageNew.id })) {
            props.push({
                displayText: t("loadFrom"),
                onClick: () => {

                    // check the location is selected - valid
                    if (validateLocationSelection() === false) {
                        promptMessage(false, t(`pleaseSelectAnyLocation`))
                        return false;
                    }

                    // setOpenSearchDocuments(true)
                    setLoadDocumentConfig(prev => ({ ...prev, show: true }))

                    return true;
                }
            })
        }

        return props
    }

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        const selected = getLocationIds()
        return selected && selected.length === 1
    }

    const updateStateFromSearchDocument = (props) => {

        try {

            // check the location is selected - valid
            if (validateLocationSelection() === false) {
                promptMessage(false, t(`pleaseSelectAnyLocation`))
                return false;
            }

            updateFormikState({
                data: props?.data,
                routeType,
                setFieldValue,
            })


        } catch (error) {
            promptMessage(false, `Load failed : ${error}`)
        }

        return true;
    }

    const calculateSummaryValues = () => {

        if (!values) return false;

        try {
            // const { totalAmount } = 
            calculateSummaryRows({
                // formikValues: values,
                // setFieldValue,
                handleValueRow: ({ subTotal, index }) => {
                    setFieldValue(`rows.${index}.subtotal`, subTotal.toFixed(2))
                },
            })

            // setFieldValue(`totalamount`, totalAmount.toFixed(2))

        } catch (error) {
            promptMessage(false, `Error in summary calculation : ${error}`)
        }

        return true;

    }

    const handleAddItem = ({ rows, setFieldValue }) => {

        rows.push(initialRowValues);
        setFieldValue('rows', rows)

    }

    const handleRemoveItem = ({ rows, index, setFieldValue }) => {

        const currentLine = rows ? rows.length : 0;

        if (currentLine <= 1) {
            promptMessage(false, t(`itemsAtLeastHave1Row`))
            return false;
        }

        const newRows = rows.filter((i, ind) => ind !== index)

        // rows.remove(index);
        setFieldValue('rows', newRows)

        return true;

    }

    const RenderRows = () => {

        const rows = values?.rows;

        return (
            <Box
            >
                <Box
                >
                    {
                        rows && rows.length > 0
                        && rows.map((item, index) => {

                            const itemValues = item;
                            let itemTouched = touched?.rows
                            let itemErrors = errors?.rows
                            // const itemTouched = touched?.rows

                            if (itemTouched) {
                                itemTouched = (itemTouched[index] !== undefined) ? itemTouched[index] : {};
                            }

                            if (itemErrors) {
                                itemErrors = (itemErrors[index] !== undefined) ? itemErrors[index] : {};
                            }

                            return (
                                <Grid key={index} item xs={12} sm={12} md={12}>

                                    <Grid container spacing={0.5} >

                                        <Grid item xs={12} sm={12} md={0.5} alignSelf={"center"}>
                                            <IconButton
                                                aria-label="delete"
                                                onClick={() => handleRemoveItem({ rows: values.rows, index, setFieldValue })}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3.5}>

                                            <SearchItems
                                                id={`rows.${index}.name`}
                                                handleOnCancel={() => { }}
                                                handleOnSearchChange={(event) => {
                                                    setFieldValue(`rows.${index}.name`, `${event.target.value}`)
                                                }}
                                                handleOnSelect={({ id, item }) => {
                                                    // console.log('id', id, item)
                                                    setFieldValue(`rows.${index}.itemId`, item?.id)
                                                    setFieldValue(`rows.${index}.name`, item?.item_name)
                                                    setFieldValue(`rows.${index}.description`, item?.description)
                                                    setFieldValue(`rows.${index}.code`, item?.code)
                                                    setFieldValue(`rows.${index}.uomName`, item?.uom_name)
                                                    setFieldValue(`rows.${index}.uomId`, item?.uom_id)
                                                    setFieldValue(`rows.${index}.qty`, 1)
                                                    setFieldValue(`rows.${index}.price`, item?.uom_price)
                                                }}
                                                textProps={{
                                                    disabled: true,
                                                    value: itemValues?.name ? itemValues.name : "",
                                                    error: Boolean(itemErrors?.name),
                                                    helperText: itemErrors?.name
                                                }}
                                            />

                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                disabled
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.uomName`}
                                                label={t("uom")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.uomName ? itemValues.uomName : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.uomName)}
                                                helperText={itemErrors?.uomName}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={3.5}>
                                            <TextField
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.description`}
                                                label={t("description")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.description ? itemValues.description : ""}
                                                onChange={handleChange}
                                                error={Boolean(itemErrors?.description)}
                                                helperText={itemErrors?.description}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "center"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.qty`}
                                                label={t("qty")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.qty ? itemValues.qty : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.qty`, event.target.value);
                                                    // handleDisplayRowChange({ index, qty: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.qty)}
                                                helperText={itemErrors?.qty}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                name={`rows.${index}.price`}
                                                label={t("cost")}
                                                type="text"
                                                variant="outlined"
                                                value={itemValues?.price ? itemValues.price : ""}
                                                onChange={(event) => {
                                                    setFieldValue(`rows.${index}.price`, event.target.value);
                                                    // handleDisplayRowChange({ index, price: event.target.value});
                                                }}
                                                error={Boolean(itemErrors?.price)}
                                                helperText={itemErrors?.price}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={12} md={1.5}>
                                            <TextField
                                                inputProps={{
                                                    style: {
                                                        textAlign: "right"
                                                    }
                                                }}
                                                margin="dense"
                                                size="small"
                                                fullWidth
                                                disabled
                                                name={`rows.${index}.subtotal`}
                                                label={t("subTotal")}
                                                value={itemValues?.subtotal ? itemValues.subtotal : "0.00"}
                                                type="text"
                                                variant="outlined"
                                            />
                                        </Grid>

                                    </Grid>
                                </Grid>
                            )
                        })
                    }
                </Box>

                <Grid item xs={12}>
                    <Divider sx={{ mt: 1, mb: 0 }} />
                </Grid>

                {
                    RenderSummaryRow({ values, errors, touched, handleChange, setFieldValue })
                }

            </Box>
        )
    }

    // const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
    //     return (
    //         <Grid item xs={12} sm={12} md={12}>

    //             <Grid container spacing={0.5}>

    //                 <Grid item xs={12} sm={12} md={4}>

    //                     <Button
    //                         variant="outlined"
    //                         sx={{ mt: 2 }}
    //                         fullWidth
    //                         startIcon={<CommonIcons name={icons.add} />}
    //                         onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
    //                     >
    //                         {t('addItem')}
    //                     </Button>

    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={5}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}

    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}

    //                         margin="normal"
    //                         size="small"
    //                         fullWidth
    //                         name={"discount.amount"}
    //                         label={t("discount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values.discount.amount}
    //                         onChange={(event) => {
    //                             setFieldValue(`discount.amount`, event.target.value);
    //                         }}
    //                         error={Boolean(errors?.discount?.amount)}
    //                         helperText={errors?.discount?.amount}
    //                     />
    //                 </Grid>

    //             </Grid>

    //             {/* <Grid container spacing={0.5}>

    //                 <Grid item xs={12} sm={12} md={7}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={2}>
    //                     <FormControl
    //                         margin="normal"
    //                         fullWidth
    //                         size="small"
    //                         error={Boolean(errors?.tax?.id)}
    //                     >
    //                         <InputLabel id="taxId">Tax</InputLabel>
    //                         <Select
    //                             labelId="taxId"
    //                             label="Tax"
    //                             name={"taxId"}
    //                             onChange={(event) => {
    //                                 setFieldValue(`tax.id`, event.target.value)
    //                             }}
    //                             value={
    //                                 checkValueExists({ 
    //                                     dataSearch: taxTypesArray, 
    //                                     valueToCompare: values.tax.id 
    //                                 })
    //                             }
    //                             sx={{
    //                                 textAlign: 'left'
    //                             }}
    //                         >
    //                             {
    //                                 taxTypesArray.map((i, index) => {
    //                                     return (
    //                                         <MenuItem key={index} value={i.id}>{i.name}</MenuItem>
    //                                     )
    //                                 })
    //                             }
    //                         </Select>
    //                         <FormHelperText>
    //                             {errors?.tax?.id}
    //                         </FormHelperText>
    //                     </FormControl>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}
    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}
    //                         margin="normal"
    //                         size="small"
    //                         disabled
    //                         fullWidth
    //                         name={"tax.amount"}
    //                         label="Tax Amount"
    //                         type="text"                                         
    //                         variant="outlined"
    //                         value={values?.tax?.amount? values.tax.amount : "0.00"}
    //                         // onChange={handleChange}
    //                         // error={touched.total && Boolean(errors.total)}
    //                         // helperText={touched.total && errors.total}
    //                     />
    //                 </Grid>
    //             </Grid> */}

    //             <Grid container spacing={0.5}>

    //                 <Grid item xs={12} sm={12} md={9}>
    //                     <></>
    //                 </Grid>

    //                 <Grid item xs={12} sm={12} md={3}>
    //                     <TextField
    //                         inputProps={{
    //                             style: {
    //                                 textAlign: "right"
    //                             }
    //                         }}
    //                         InputProps={{
    //                             startAdornment: (
    //                                 <InputAdornment position="start">
    //                                     <CommonIcons name={icons.equal} />
    //                                 </InputAdornment>
    //                             ),
    //                         }}
    //                         margin="normal"
    //                         size="small"
    //                         disabled
    //                         fullWidth
    //                         name={"totalamount"}
    //                         label={t("totalAmount")}
    //                         type="text"
    //                         variant="outlined"
    //                         value={values?.totalamount ? values.totalamount : "0.00"}
    //                     // onChange={handleChange}
    //                     // error={touched.total && Boolean(errors.total)}
    //                     // helperText={touched.total && errors.total}
    //                     />
    //                 </Grid>
    //             </Grid>
    //         </Grid>
    //     )
    // }

    const RenderSummaryRow = ({ values, errors, touched, handleChange, setFieldValue }) => {
        return (
            <Grid item xs={12} sm={12} md={12}>

                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={4}>

                        <Button
                            variant="outlined"
                            sx={{ mt: 2 }}
                            fullWidth
                            startIcon={<CommonIcons name={icons.add} />}
                            onClick={() => handleAddItem({ rows: values.rows, setFieldValue })}
                        >
                            {t("addItem")}
                        </Button>

                    </Grid>

                    <Grid item xs={12} sm={12} md={3}>
                        <></>
                    </Grid>

                    <Grid item xs={12} sm={12} md={5}>

                        {
                            RenderDocumentSummary()
                        }

                    </Grid>

                </Grid>

            </Grid>
        )
    }

    const RenderFormLocation = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`location`)}
                            subTitle={t(`relatedWarehouseLocationToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={10.5}>
                        <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label={t("location")}
                            type="text"
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        />
                    </Grid>
                    <Grid item md={1.5}>
                        <IconButton
                            color="primary"
                            sx={{
                                // pt: 0
                            }}
                            onClick={() => {
                                setLocationIds([])
                            }}
                        >
                            <StyledIcon
                                sx={{
                                    width: 25,
                                    height: 25,
                                    m: 0,
                                    p: 0
                                }}
                            >
                                <CommonIcons name={icons.edit} />
                            </StyledIcon>
                        </IconButton>
                    </Grid>

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormProfiles = () => {
        return (
            <StyledCard sx={{ mt: 1 }}>

                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`profile`)}
                            subTitle={t(`relatedProfilesToProcess`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12}>
                        {/* <TextField
                            disabled
                            margin="dense"
                            size="small"
                            fullWidth
                            name={"locationId"}
                            label="Location"
                            type="text"                                         
                            variant="outlined"
                            value={values.locationName}
                            error={touched.locationId && Boolean(errors.locationId)}
                            helperText={touched.locationId && errors.locationId}
                        /> */}
                        <SearchSuppliers
                            routeType={routeType}
                            handleOnCancel={() => {

                            }}
                            handleOnSelect={(props) => {

                                const { id, item } = props
                                setFieldValue('username', item?.company_name)
                                setFieldValue('userId', item?.user_id)

                            }}
                            textProps={{
                                disabled: true,
                                value: values.username,
                                error: Boolean(errors?.userId),
                                helperText: errors?.userId
                            }}
                        />
                    </Grid>
                    {/* <Grid item xs={12} sm={12} md={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.billingBranchId && Boolean(errors.billingBranchId)}
                        >
                            <InputLabel id="rack-label">Bill To</InputLabel>
                            <Select
                                // labelId="rack-label"
                                // id="rack_id"
                                value={values?.billingBranchId}
                                name={`billingBranchId`}
                                label="billingBranchId"
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`billingBranchId`, event.target.value)
                                }}
                            >
                                {
                                    dataBranches && dataBranches.map((item, index) => 
                                        <MenuItem key={index} value={item.id}>{item.branch_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.billingBranchId && errors.billingBranchId}
                            </FormHelperText>
                        </FormControl>
                    </Grid> */}

                    {/* <Grid item xs={12} sm={12} md={12}>
                        <FormControl
                            margin="dense"
                            fullWidth
                            size="small"
                            error={touched.shippingBranchId && Boolean(errors.shippingBranchId)}
                        >
                            <InputLabel id="rack-label">Ship To</InputLabel>
                            <Select
                                // labelId="rack-label"
                                // id="rack_id"
                                value={values?.shippingBranchId}
                                name={`shippingBranchId`}
                                label="shippingBranchId"
                                margin="dense"
                                size="small"
                                onChange={(event) => {
                                    setFieldValue(`shippingBranchId`, event.target.value)
                                }}
                            >
                                {
                                    dataShipping && dataShipping.map((item, index) => 
                                        <MenuItem key={index} value={item.id}>{item.branch_name}</MenuItem>
                                    )
                                }
                            </Select>
                            <FormHelperText>
                                {touched.shippingBranchId && errors.shippingBranchId}
                            </FormHelperText>
                        </FormControl>
                    </Grid> */}

                </Grid>
            </StyledCard>
        )
    }

    const RenderFormDocument = () => {
        return (
            <StyledCard>
                <Grid container spacing={0.5}>
                    <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t(`document`)}
                            subTitle={t(`basicInformationAboutTheDocument`)}
                        />

                    </Grid>
                    <Grid item xs={12} sm={12} md={12} sx={{ mt: 2 }}>
                        <Grid container spacing={0.5}>

                            <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                                <DatePickerComponent
                                    config={{
                                        name: "documentDate",
                                        label: t("documentDate")
                                    }}
                                    formik={{
                                        values,
                                        errors,
                                        touched,
                                        handleChange,
                                        setFieldValue
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    fullWidth
                                    name={"remark"}
                                    label={t("remark")}
                                    type="text"
                                    variant="outlined"
                                    multiline
                                    rows={3}
                                    value={values.remark}
                                    onChange={handleChange}
                                    error={touched.remark && Boolean(errors.remark)}
                                    helperText={touched.remark && errors.remark}
                                />
                            </Grid>

                        </Grid>
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderForm = () => {

        return (
            <form onSubmit={handleSubmit}>

                <Grid container spacing={1}>

                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>


                    <Grid item xs={12} sm={12} md={6} textAlign={"left"}>

                        {
                            RenderFormLocation()
                        }

                        {
                            RenderFormProfiles()
                        }

                    </Grid>

                </Grid>
                <StyledCard sx={{ mt: 1 }}>
                    <Grid container rowSpacing={0}>
                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t(`items`)}
                                subTitle={t(`detailInformationAboutTheItemsInvolved`)}
                            />

                        </Grid>

                        <Grid item xs={12} sm={12} md={12} textAlign={"left"}>

                            {
                                RenderRows()
                            }

                            {/* <FieldArray
                                    name="rows"
                                    render={(arrayHelpers) => {
                                        
                                        return RenderRow({ values, errors, touched, handleChange, setFieldValue, arrayHelpers})
                                    
                                    }}
                                /> */}
                        </Grid>

                    </Grid>
                </StyledCard>
                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>

            </form>
        )
    }

    const RenderAll = () => {
        return validateLocationSelection() ?
            (
                RenderForm()
            )
            :
            (
                <LocationSelector
                    config={{
                        title: t("selectOnly1Location"),
                        description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
                    }}
                    maxSelect={1}
                    handleOnNext={({ selected }) => {

                        setLocationIds([selected[0].id])
                        setFieldValue(`locationId`, selected[0].id)
                        setFieldValue(`locationName`, selected[0].location_name)

                    }}
                />
            )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newPurchaseInvoice })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("newPurchaseInvoice")}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    {
                        displayText: t("purchaseInvoices"),
                        props: {
                            href: getRoute('documents/purchaseInvoices')
                        }
                    },
                    {
                        displayText: t("newPurchaseInvoice"),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderAll()
                    :
                    <CommonRestricted />
            }

            {
                loadDocumentConfig?.show &&

                <LoadFromDocuments
                    fromDocumentId={loadDocumentConfig?.documentId}
                    fromDocumentType={loadDocumentConfig?.documentType}
                    show={loadDocumentConfig?.show}
                    filledSearchKeyword={loadDocumentConfig?.keyword}
                    handleOnCancel={() => {
                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))
                    }}
                    handleOnSelect={(props) => {

                        setLoadDocumentConfig(prev => ({ ...prev, show: false }))

                        // console.log('props', props)

                        // load the data into the state
                        updateStateFromSearchDocument(props)

                    }}
                />
            }

            {
                RenderDocumentTaxPreview()
            }

        </Box>
    )
}